(function () {
  function initSliderDots(dotsWrap) {
    if (dotsWrap.dataset.dotsInitialized === 'true') return;

    const sliderId = dotsWrap.dataset.sliderDots;
    if (!sliderId) return;

    const slider = document.getElementById('Slider-' + sliderId);
    if (!slider) return;

    const panel = dotsWrap.closest('[data-bestsellers-panel]');
    if (panel?.hasAttribute('hidden')) return;

    const dots = dotsWrap.querySelectorAll('.product-slider-dots__dot');
    const items = slider.querySelectorAll('[id^="Slide-"]');
    if (!dots.length || !items.length) return;

    const setActiveDot = (index) => {
      dots.forEach((dot, i) => {
        dot.classList.toggle('product-slider-dots__dot--active', i === index);
      });
    };

    const getActiveIndex = () => {
      const scrollLeft = slider.scrollLeft;
      let activeIndex = 0;
      let closestDistance = Infinity;

      items.forEach((item, index) => {
        const distance = Math.abs(item.offsetLeft - scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          activeIndex = index;
        }
      });

      return activeIndex;
    };

    slider.addEventListener(
      'scroll',
      () => {
        setActiveDot(getActiveIndex());
      },
      { passive: true }
    );

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.index, 10);
        const item = items[index];
        if (!item) return;

        slider.scrollTo({
          left: item.offsetLeft,
          behavior: 'smooth',
        });
        setActiveDot(index);
      });
    });

    setActiveDot(getActiveIndex());
    dotsWrap.dataset.dotsInitialized = 'true';
  }

  function initAll(scope) {
    const root = scope || document;
    root.querySelectorAll('.product-slider-dots[data-slider-dots]').forEach(initSliderDots);

    /* Legacy class support */
    root.querySelectorAll('.shop-our-bestsellers__dots[data-slider-dots]').forEach((wrap) => {
      if (!wrap.classList.contains('product-slider-dots')) initLegacyDots(wrap, 'shop-our-bestsellers__dot', 'shop-our-bestsellers__dot--active');
    });
    root.querySelectorAll('.bestsellers__dots[data-slider-dots]').forEach((wrap) => {
      if (!wrap.classList.contains('product-slider-dots')) initLegacyDots(wrap, 'bestsellers__dot', 'bestsellers__dot--active');
    });

    if (window.DEFWishlist && typeof window.DEFWishlist.initFavButtons === 'function') {
      window.DEFWishlist.initFavButtons(root);
    }
  }

  function initLegacyDots(dotsWrap, dotClass, activeClass) {
    if (dotsWrap.dataset.dotsInitialized === 'true') return;
    const sliderId = dotsWrap.dataset.sliderDots;
    const slider = document.getElementById('Slider-' + sliderId);
    if (!slider) return;
    const dots = dotsWrap.querySelectorAll('.' + dotClass);
    const items = slider.querySelectorAll('[id^="Slide-"]');
    if (!dots.length || !items.length) return;

    const setActiveDot = (index) => {
      dots.forEach((dot, i) => dot.classList.toggle(activeClass, i === index));
    };

    slider.addEventListener('scroll', () => {
      let activeIndex = 0;
      let closestDistance = Infinity;
      items.forEach((item, index) => {
        const distance = Math.abs(item.offsetLeft - slider.scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          activeIndex = index;
        }
      });
      setActiveDot(activeIndex);
    }, { passive: true });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const item = items[parseInt(dot.dataset.index, 10)];
        if (item) slider.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      });
    });

    dotsWrap.dataset.dotsInitialized = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  window.initBestsellersSliderDots = initAll;
})();
